
import {ApolloClient, gql} from '@apollo/client';

export type ImageType = 'BMD' | 'Fat Mass' | 'PST';

export interface Images {
	start: {
		full: string
		unix: string
		date: string
	}

	images: {
		type: ImageType
		width: number
		height: number
		values: string
	}[]
}

export interface Vars {
	appts: string[],
}

export interface Result {
	reports: {
		dexaImages: Images[]
	}
}

const query = gql`
query ($appts: [ID!]!) {
    reports {
		id
		dexaImages(appts: $appts) {
			start {
				full: time(fmt: "Jan 02, 2006 at 3:04pm")
				unix
				date: time(fmt: "Jan 2, 2006")
			}
			images {
				type
				width
				height
				values
			}
		}
    }
}`;

export const getImages = (
	client: ApolloClient<object>,
	appts: string[],
) => (
	client.query<Result, Vars>({
		context: {
			slowQuery: true,
		},
		query,
		variables: {
			appts,
		},
	})
);
